import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SyncIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sync"}/>
}
